import React from "react"

export default function FormStatus({ statusDisplay, message }) {
  return (
    <div className="form__section">
      <div className="Form__Status">
        <p className={`Form__Status__Message ${statusDisplay}`} data-f-form-statusmessage>
          {message}
        </p>
      </div>
    </div>
  )
}
